import classNames from 'classnames'
import React, { FC, useContext, useEffect } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { ChatContext } from '~/service/chatConn'
import { FormType } from '.'
import { RenderPropsTyped } from '~/components/common/Form'

type Props = {
  inputRef: React.MutableRefObject<HTMLTextAreaElement | undefined>
  renderProps: RenderPropsTyped<FormType, 'content'>
  autocompleteActiveRef: React.MutableRefObject<string | undefined>
  redirectToUser?: number
  redirectToStory?: number
  hidden: boolean
  submit: () => void
}

const MainInput: FC<Props> = ({
  inputRef,
  renderProps,
  autocompleteActiveRef,
  redirectToUser,
  redirectToStory,
  hidden,
  submit,
}) => {
  const { field } = renderProps

  const { activeChat, aiCompletionApplied } = useContext(ChatContext)
  const disabled = !!activeChat.aiCompletion

  useEffect(() => {
    if (activeChat.aiCompletion && activeChat.aiCompletion.content.length) {
      field.onChange(activeChat.aiCompletion.content + ' ⬤')
    }

    if (activeChat.aiCompletion && activeChat.aiCompletion.done) {
      aiCompletionApplied(activeChat.id)
    }
  }, [
    activeChat.aiCompletion && activeChat.aiCompletion.content,
    activeChat.aiCompletion && activeChat.aiCompletion.done,
  ])

  useEffect(() => {
    if (!activeChat.aiCompletion && field.value.endsWith(' ⬤')) {
      field.onChange(field.value.replace(' ⬤', ''))
    }
  }, [!!activeChat.aiCompletion])

  useEffect(() => {
    if (!redirectToStory && !disabled) {
      inputRef.current?.focus()
    }
  }, [redirectToStory, disabled])

  useEffect(() => {
    if (activeChat.aiCompletion) {
      inputRef.current?.scrollTo(0, inputRef.current.scrollHeight)
    }
  }, [field.value.length])

  const label = intl
    .formatMessage({
      id: 'chat / input / main / placeholder',
    })
    .split(' / ')

  const placeholder =
    redirectToUser && !field.value.length ? (
      <>
        {intl.formatMessage({
          id: 'chat / input / main / placeholder / redirect to user',
        })}
      </>
    ) : !field.value.length ? (
      <>
        {label[0]}
        <div>
          <div>/</div>
        </div>
        {label[1]}
      </>
    ) : (
      false
    )

  return (
    <>
      {!hidden && (
        <div className="chat-input-textarea-placeholder">{placeholder}</div>
      )}

      <TextareaAutosize
        id="main-input"
        onKeyDown={e => {
          if (
            e.key == 'Enter' &&
            !e.shiftKey &&
            !autocompleteActiveRef.current
          ) {
            e.preventDefault()
            submit()
          }
        }}
        className={classNames({ 'is-hidden': hidden })}
        rows={1}
        minRows={1}
        maxRows={10}
        disabled={disabled}
        {...field}
        ref={ref => {
          field.ref(ref)

          inputRef.current = ref!
        }}
      />
    </>
  )
}

export default MainInput
